export default {
  getText: (ary, key) => {
    const fil = ary.filter(r => r.value === key)
    return fil.length > 0 ? fil[0].text : 'none'
  },
  getShortText: (ary, key) => {
    const fil = ary.filter(r => r.value === key)
    return fil.length > 0 ? fil[0].shortText : 'none'
  }
}



// WEBPACK FOOTER //
// ./src/lib/dict.js